import React, {Component} from 'react';
import {Col, Container, Row} from 'reactstrap';
import logo from './img/logo.svg';
import './App.css';
import QueryString from 'query-string'
import {InputBlock} from "./InputBlock";
import {CavitationChart} from "./charts/CavitationChart";
import {DisclaimerModal} from "./DisclaimerModal";
import {ContactBlock} from "./ContactBlock";
import {CalculationBlock} from "./CalculationBlock";
import {CalculationMessages} from "./CalculationMessages";
import {ProductFinder} from "./ProductFinder";
import {VersionBlock} from "./VersionBlock";
import {PrintButton} from "./PrintButton";
import PropTypes from "prop-types";
import {ValveCapacityChart} from "./charts/ValveCapacityChart";
import {LinkQR} from "./LinkQR";
import {LongLink} from "./LongLink";
import {DescriptionBox} from "./DescriptionBox";
import {Strings} from "./Strings";

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {inputData: props.inputData};
        this.handleInputChange = this.handleInputChange.bind(this);
        this.onDisclaimerAccept = this.onDisclaimerAccept.bind(this);
    }

    handleInputChange(newInput) {
        this.setState({inputData: newInput})
    }

    onDisclaimerAccept() {
        sessionStorage.isDisclaimerAccepted = true;
        this.setState({}); //Triggers re-render
    }

    render() {
        this.updateQueryString();

        return (
            <div className="App">
                <DisclaimerModal onAccept={this.onDisclaimerAccept}
                                 isAccepted={Boolean(sessionStorage.isDisclaimerAccepted)}/>
                <div className="App-header-bg">
                    <Container>
                        <header className="App-header">
                            <Row>
                                <Col md="auto">
                                    <img src={logo} className="App-logo" alt={Strings.AVK}/>
                                </Col>
                                <Col md="auto" className="d-flex align-items-center">
                                    <h1 className="App-title">{Strings.title}</h1>
                                </Col>
                            </Row>
                        </header>
                    </Container>
                </div>
                <Container className="App-content">
                    <Row>
                        <DescriptionBox onChange={this.handleInputChange}
                                        inputData={this.state.inputData}/>
                    </Row>
                    <Row>
                        <Col><h2>{Strings.titleInput}</h2>
                            <InputBlock inputData={this.state.inputData} onChange={this.handleInputChange}/>
                        </Col>
                    </Row>
                    <Row>
                        <ValveCapacityChart inputData={this.state.inputData} onChange={this.handleInputChange}/>
                        <Col lg="4">
                            <Row>
                                <Col><CavitationChart inputData={this.state.inputData}/></Col>
                            </Row>
                            <Row>
                                <CalculationBlock inputData={this.state.inputData}/>
                            </Row>
                        </Col>
                    </Row>
                    <Row>
                        <CalculationMessages lg="8" inputData={this.state.inputData}/>
                        <ContactBlock lg="4" location={this.props.location}/>
                    </Row>
                    <Row className="d-print-none">
                        <ProductFinder md="8" location={this.props.location} inputData={this.state.inputData}/>
                        <PrintButton/>
                    </Row>
                    <Row>
                        <Col>
                            <h2>{Strings.titleSaveCalculation}</h2>
                            <Row>
                                <LongLink md={8}/>
                                <LinkQR md={4}/>
                            </Row>
                        </Col>
                    </Row>
                    <Row><VersionBlock/></Row>
                </Container>
            </div>
        );
    }

    updateQueryString() {
        const parsed = QueryString.parse(window.location.search);
        parsed.vd = this.state.inputData.valveDimension;
        parsed.vb = this.state.inputData.valveBore;
        parsed.ip = this.state.inputData.inletPressure;
        parsed.op = this.state.inputData.outletPressure;
        parsed.fl = this.state.inputData.flow;
        parsed.v = this.props.version;
        parsed.xd = this.state.inputData.description;
        parsed.loc = this.props.location;
        window.history.replaceState({}, null, "?" + QueryString.stringify(parsed));
    }
}

App.propTypes = {
    inputData: PropTypes.shape({
        flow: PropTypes.number,
        inletPressure: PropTypes.number,
        outletPressure: PropTypes.number,
        valveDimension: PropTypes.number,
        valveBore: PropTypes.number,
        description: PropTypes.string
    }).isRequired
};

export default App;
